import type { HomeContentSource } from '../domain/repositories/HomeContentSource.interface';
import type { HeroContentInput } from '../domain/value-objects/HeroContent.vo';
import { homeHeroContent } from '../content/home.content';

/**
 * Infrastructure implementation of `HomeContentSource`, backed by a static
 * local module. Returns a Promise to keep the interface stable for a future
 * `SupabaseHomeContentSource` (once Settings/CMS content exists) — the
 * Application layer already does not know or care which one is active.
 */
export class StaticHomeContentSource implements HomeContentSource {
  public async getHeroContent(): Promise<HeroContentInput> {
    return homeHeroContent;
  }
}
